var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container-readonly"},[_c('div',{staticClass:"toolbar-wrapper"},[_c('div',{ref:"toolbarRef",staticClass:"toolbar",staticStyle:{"display":"none"}})]),_c('div',{ref:"editorRef",staticClass:"editor-content",style:({border: 'none',height: _vm.minHeight})})])
}
var staticRenderFns = []

export { render, staticRenderFns }